import Core from "../Core";

function createOrderPageRoute(baseRouteUrl, slug, id) {
  return `${baseRouteUrl}${Core.routing.routingSegments.SEGMENT_ORDER}/${slug}/${id}`;
}

export default createOrderPageRoute;
